import React, { Component } from 'react';
import { DateRange, Calendar  } from 'react-date-range';  
import { Button } from 'react-bootstrap';
import moment from 'moment';

function getNextFriday(date, dayOfWeek) {
  var resultDate = new Date(date.getTime());

  resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
  return moment(resultDate).format('YYYY-MM-DD');
}

export class DateRangeCalendar extends Component {
constructor(props){
    super(props);

    this.state = {
        dateRange: {
          selection: {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
          },
        },
    };

}    

    handleRangeChange(which, payload) {
      this.setState({
        [which]: {
          ...this.state[which],
          ...payload,
        },
      });
      // this.props.selection(which,payload)
    }

    sendSelection(){
      this.props.selection('dateRange',this.state.dateRange)
    }

	render(){
		return (
            <section title="RangePicker">
                <DateRange
                    onChange={this.handleRangeChange.bind(this, 'dateRange')}
                    moveRangeOnFirstSelection={false}
                    ranges={[this.state.dateRange.selection]}
                    className={'PreviewArea'}
                />
                <Button onClick={() => this.sendSelection()}>OK</Button>
            </section>
		)
	}
}

export class DatePicker extends Component {
  constructor(props){
      super(props);

      this.handleSelect = this.handleSelect.bind(this);

      this.state = {
          date : new Date(),
          err: null
      };
  }

  componentDidMount(){
    if(this.props.date !== this.state.date){
      this.setState({
        date: this.props.date
      });
    }
  }      

  componentDidUpdate(){
    if(this.props.date !== this.state.date){
      this.setState({
        date: this.props.date
      });
    }
  }  
  
  handleSelect(date){  
    this.setState({
      date : date
    });
    this.props.selection(date);
	}
  
    render(){
      return (
              <section title="RangePicker" style={{transform: "translate(0px, -30px)"}}>
                  <Calendar
                    date={this.state.date}
                    onChange={this.handleSelect}
                  />
                  <p className="text-danger"><small>{this.state.err}</small></p>
              </section>
      );
    }
  }